// {
//     "baseUrl": "https://app.wehaul247.com/api/v1",
//     "herokuBaseUrl": "https://app.wehaul247.com/api/v1",
//     "googleApiKey": "AIzaSyA8kxgU38wJpJWddYFJszURwJ9xkE2L1NQ"
// }

export const baseUrl = "https://app.wehaul247.com/api/v1"